/**
 * @module views\std\bom
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhTablePage from "@/components/ghTablePage/ghTablePage";
import GhBase from "@/components/ghBase";

@Component
export default class Bom extends GhBase {
  private args = { version_id: "", keyword: "" };

  private bomVersion: IndexObject | null = null;

  private templateModel: IndexObject = {};

  protected onNavigateTo(parames) {
    if (parames.MaterialCd && parames.Id) {
      this.bomVersion = parames;
      if (this.bomVersion) {
        this.args.version_id = this.bomVersion.Id;
        this.templateModel.versionId = this.bomVersion.Id;
        this.templateModel.MaterialCd = this.bomVersion.MaterialCd;
        this.templateModel.MaterialCtrl = this.bomVersion.MaterialCtrl;
        this.templateModel.MaterialName = this.bomVersion.MaterialName;
        this.templateModel.PackSpec = this.bomVersion.规格;
        this.templateModel.母件单位 = this.bomVersion.单位;
        this.templateModel.分母 = 100.0;
        this.query();
      }
    }
  }

  protected onNavigateLeave() {
    this.args.version_id = "";
    this.bomVersion = null;
    this.templateModel = {};
  }

  private query() {
    let page = this.$refs.tabel as GhTablePage;
    if (page) {
      page.query();
    }
  }

  private submit(values: IndexObject[]) {
    let page = this.$refs.table as GhTablePage;
    if (page) {
      values.forEach(value => {
        let model = Object.assign({}, this.templateModel);
        page.saveItem(model);
      });
      // for (const value of values) {

      // }
    }
  }
}
